module.exports = __webpack_public_path__ + "media/images/number_0_red-a12b00e38379eea818ef3fd9fdcbb481.png";